// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"style_formWrapper__dl_kU","submissionStatus":"style_submissionStatus__nP4Nr","form":"style_form__aX71J"};